import { render, staticRenderFns } from "./list.vue?vue&type=template&id=913b4efe&scoped=true&"
import script from "./list.vue?vue&type=script&lang=js&"
export * from "./list.vue?vue&type=script&lang=js&"
import style0 from "./list.vue?vue&type=style&index=0&id=913b4efe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913b4efe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('913b4efe')) {
      api.createRecord('913b4efe', component.options)
    } else {
      api.reload('913b4efe', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=913b4efe&scoped=true&", function () {
      api.rerender('913b4efe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/client/clientInheritRecord/list.vue"
export default component.exports